import { useUserStore } from "@/stores/userStore";
import { App, Plugin } from "vue";
import UserDto from "./interfaces/IUserDto";

// Vue helpers
export const userhelpers = {
	install(app: App) {
		app.config.globalProperties.$user = () => useUserStore().user;
		app.config.globalProperties.$userIsSuper = () => useUserStore().isSuper;
	},
} as Plugin;

declare module "@vue/runtime-core" {
	//Bind to `this` keyword
	interface ComponentCustomProperties {
		$user: () => UserDto|null;
		$userIsSuper: () => boolean;
	}
}

export default userhelpers;